import { Box, Button, Progress, Text } from "@mantine/core";
import { BookRounded } from "@mui/icons-material";
import Link from "next/link";
import classes from "./SubTopicCompletionCard.module.css";

type SubtopicProgressItemProps = {
  subTopicLabel: string;
  subTopicTitle: string;
  completed: number;
  total: number;
  percentage: number;
  href: string;
  subjectColorIndex: string;
};

export default function SubTopicCompletionCard({
  subTopicLabel,
  subTopicTitle,
  completed,
  total,
  percentage,
  href,
  subjectColorIndex,
}: SubtopicProgressItemProps) {
  return (
    <Box className={classes.wrapper}>
      <Box className={classes.contentBox}>
        <Text className={classes.subtopicTitle}>
          {subTopicLabel}: {subTopicTitle}
        </Text>
        <Text className={classes.countText}>
          {completed}/{total}
        </Text>
        <Text className={classes.percentageText}>
          {Math.round(percentage)}%
        </Text>

        <Progress
          value={percentage}
          size="sm"
          radius="xs"
          className={classes.progressBar}
          color={subjectColorIndex}
        />
      </Box>

      <Button
        component={Link}
        href={href}
        color={"darkblue"}
        size="xs"
        className={classes.continueButton}
        leftSection={<BookRounded style={{ width: 16, height: 16 }} />}
      >
        Study
      </Button>
    </Box>
  );
}

export const useCompletionCardStyles = (_args?: {
  subjectColorIndex?: string;
}) => ({ classes });
